import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaryTableDataEnum } from 'models/enums/bary-table.enum';
import { TransportOrderExtendedService } from '../../../services/transport-order-extended.service';

@Component({
  selector: 'jhi-my-transports',
  templateUrl: './my-transports.component.html',
  styleUrls: ['./my-transports.component.scss'],
})
export class MyTransportsComponent {
  TABLE_TYPE = BaryTableDataEnum;

  constructor(protected activatedRoute: ActivatedRoute, public transportOrderService: TransportOrderExtendedService) {}

  protected readonly TYPE = BaryTableDataEnum;
}
